var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EthersLiquity, ReadableEthersLiquity, } from '@sovryn-zero/lib-ethers';
import { getProvider } from '@sovryn/ethers-provider';
import { getRskChainId } from './chain';
let cachedLiquity;
export const loadLiquity = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!cachedLiquity) {
        const provider = yield ReadableEthersLiquity.connect(getProvider(getRskChainId()), { useStore: 'blockPolled' });
        const liquity = new EthersLiquity(provider);
        cachedLiquity = {
            liquity,
            provider,
        };
    }
    return cachedLiquity;
});
